import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";

const Auth0Login = () => {
    const { loginWithRedirect, isAuthenticated } = useAuth0();

    useEffect(() => {
        if (!isAuthenticated) {
            loginWithRedirect();
        }
    }, [isAuthenticated, loginWithRedirect]);

    return <div>Redirecting to login...</div>;
};

export default Auth0Login;